import $ from 'jquery';

import App from '@components/App';

class Faq extends App{
    constructor() {
        super();
    }

    bindEvents() {
        $(() => {
            //on document ready
        });
    }

    init() {
        ENV === 'development' && console.log('Faq::init()');

        this.bindEvents();

        super.init();

    }
}

export default Faq;
